import * as types from './actionTypes';

export function getCountriesRequest(payload) {
  return {
    type: types.GET_COUNTRIES_REQUEST,
    payload,
  };
}

export function getCountriesSuccess(payload) {
  return {
    type: types.GET_COUNTRIES_SUCCESS,
    payload,
  };
}

export function getCountriesFailure(error) {
  return {
    type: types.GET_COUNTRIES_FAILURE,
    error,
  };
}

export function getCountriesCached() {
  return {
    type: types.GET_COUNTRIES_CACHED,
  };
}

export function getSubdivisionsRequest(payload) {
  return {
    type: types.GET_SUBDIVISIONS_REQUEST,
    payload,
  };
}

export function getSubdivisionsSuccess(payload) {
  return {
    type: types.GET_SUBDIVISIONS_SUCCESS,
    payload,
  };
}

export function getSubdivisionsFailure(error) {
  return {
    type: types.GET_SUBDIVISIONS_FAILURE,
    error,
  };
}

// Province di NASCITA. Slice separato da `subdivisions` di proposito: quello e'
// condiviso con gli step indirizzo (profilo e tax interview), che vogliono le
// province di oggi. Qui l'elenco e' filtrato alla data di nascita, e scrivere
// nello stesso slice faceva vincere l'ultimo che caricava.
export function getBirthSubdivisionsRequest(payload) {
  return {
    type: types.GET_BIRTH_SUBDIVISIONS_REQUEST,
    payload,
  };
}

export function getBirthSubdivisionsSuccess(payload) {
  return {
    type: types.GET_BIRTH_SUBDIVISIONS_SUCCESS,
    payload,
  };
}

export function getBirthSubdivisionsFailure(error) {
  return {
    type: types.GET_BIRTH_SUBDIVISIONS_FAILURE,
    error,
  };
}

// Comuni. `payload` = { countryCode, subdivisionCode, date }.
// La data e' quella di nascita, non oggi: i comuni hanno un intervallo di
// validita' e il backend cerca il codice catastale a quella data.
export function getMunicipalitiesRequest(payload) {
  return {
    type: types.GET_MUNICIPALITIES_REQUEST,
    payload,
  };
}

export function getMunicipalitiesSuccess(payload) {
  return {
    type: types.GET_MUNICIPALITIES_SUCCESS,
    payload,
  };
}

export function getMunicipalitiesFailure(error) {
  return {
    type: types.GET_MUNICIPALITIES_FAILURE,
    error,
  };
}

// Svuota l'elenco quando cambiano data di nascita o provincia, cosi' la select
// non resta popolata con i comuni della combinazione precedente.
export function clearMunicipalities() {
  return {
    type: types.CLEAR_MUNICIPALITIES,
  };
}
